import { render } from "./EditorPage.vue?vue&type=template&id=6ffe5aae"
import script from "./EditorPage.vue?vue&type=script&lang=js"
export * from "./EditorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__